//按照指定长度截取字符串-按照字节截取
const handleStr = function(str, lenNum) {
  var len = 0,
    newStr = ''
  for (var i=0; i<str.length; i++) {
    if(len < lenNum) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
        len += 2;
      } else {
        len++;
      }
      newStr += str[i]
    } else if(len == lenNum){
      len++
      newStr += '...'
    }
  }
  return newStr;
}

export default {
  handleStr
}



// WEBPACK FOOTER //
// ./src/utils/util.js